import { zenworksServiceApi } from '../service/zenworksService.api';

export const uppercasePipe = (input: string): string => {
  return input.toUpperCase();
};

export const replaceDataPipe = (
  data: string,
  replaceValue: string,
  replacer: string,
): string => {
  const safeData = typeof data === 'string' ? data : '';
  const safeReplaceValue = typeof replaceValue === 'string' ? replaceValue : '';
  const safeReplacer = typeof replacer === 'string' ? replacer : '';

  if (safeReplaceValue === '') {
    return safeData;
  }

  return safeData.replaceAll(safeReplaceValue, safeReplacer);
};

export const extractErrorMessageStrings = (obj: any, result = '') => {
  if (typeof obj === 'string') {
    result += obj + ' , ';
  } else {
    for (const key in obj) {
      if (typeof obj[key] === 'string') {
        result += obj[key] + ' , ';
      } else if (typeof obj[key] === 'object') {
        result = extractErrorMessageStrings(obj[key], result);
      }
    }
  }
  return result;
};

export const findPercentage = (value: number, percentage: number) => {
  return (percentage / 100) * value;
};

export const getStatePipes = async (form: any) => {
  try {
    const result: any = await zenworksServiceApi.getState();
    if (result.success) {
      const data = result.content.map((item: any) => ({
        value: item.StateAbbreviation,
        name: item.StateName,
      }));
      let state = data ?? [];
      if (form !== null) {
        state = setDynamicFormData(form, 'State', data);
      }
      return { data: state, error: '' };
    } else {
      return { data: [], error: result.message };
    }
  } catch (error: any) {
    console.error(error);
    return { data: [], error: error.message };
  }
};

export const getCountryPipes = async (form: any) => {
  try {
    const result: any = await zenworksServiceApi.getCountry();
    if (result.success) {
      const data = result.content.map((item: any) => ({
        value: item.Country_code,
        name: item.Country_Name,
      }));

      let state = data ?? [];
      if (form !== null) {
        state = setDynamicFormData(form, 'State', data);
      }
      return { data: state, error: '' };
    } else {
      return { data: [], error: result.message };
    }
  } catch (error: any) {
    console.error(error);
    return { data: [], error: error.message };
  }
};

export const setDynamicFormData = (form: any, fieldName: any, data: any) => {
  form.formSection.map((fSection: any) => {
    fSection.formFields.map((field: any) => {
      if (field.inputLabel === fieldName) field.select.options = data;
    });
  });
  return form;
};

export const formateNumber = (number = 0) => {
  number = Number(number);
  return number.toFixed(2);
};

export const capitalizeName = (name: string) => {
  if (!name || typeof name !== 'string') return "";

  return name
    .split(" ")
    .map(str => str[0].toUpperCase() + str.slice(1).toLowerCase())
    .join(" ");
}

